import { Component, OnInit } from '@angular/core';
import { InvestorDataService } from '../../core/investor-data.service';
import { Observable } from 'rxjs/Observable';
import { error } from 'util';
import { status } from '../../core/user';
import { AngularFirestoreCollection } from 'angularfire2/firestore';
import * as firebase from 'firebase';
import { Investor } from '../shared/models/investor';

@Component({
  selector: 'app-investor-details',
  templateUrl: './investor-details.component.html',
  styleUrls: ['./investor-details.component.css']
})
export class InvestorDetailsComponent implements OnInit {
  data: Investor;
  newData: Investor;
  investors: Investor[];
  allInvestors: Investor[];
  listInvestors: AngularFirestoreCollection<Investor[]>;
  constructor(private ids: InvestorDataService) {
    // this.data = {
    //   creatorId: 'cd',
    //   personName: 'ppnane',
    //   status: status.new,
    //   createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    //   updatedAt: firebase.firestore.FieldValue.serverTimestamp()
    // };
    // this.newData = {
    //   creatorId: 'newCd',
    //   personName: 'newPname',
    //   status: status.done,
    //   updatedAt: firebase.firestore.FieldValue.serverTimestamp()
    // };
  }

  ngOnInit() {
    const x = this.ids.getKey();
    x.valueChanges().subscribe(item => {
      this.investors = item;
    });
  }

  addInvestor() {
    // this.ids.addInvestorData(this.data);
  }
  editInvestor(iid: string) {
    this.ids.editInvestorData({
      iid: iid,
      ...this.newData
    });
  }
  deleteInvestor(iid: string) {
    this.ids.deleteInvestorData(iid);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/investor-details/investor-details.component.ts